import React, { useState } from "react"
import { useSelector } from "react-redux"
import { Box, IconButton, Typography } from "@mui/material"
import AddIcon from "@mui/icons-material/Add"
import EditIcon from "@mui/icons-material/Edit"

import { getOrganizationsEnterpriseSelector } from "../../../../reducers/Organizations/organizations"
import { labelTemplates as ALL_LABEL_TEMPLATES } from "../../../../utils/productLabels"
import EditLabelTemplatesModal from "./EditLabelTemplatesModal"

const sx = {
  card: {
    bgcolor: "#FFFFFF",
    borderRadius: "4px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.06), 0 1px 1px rgba(0,0,0,0.04)",
    p: 3,
  },
  cardHead: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 2,
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 500,
    color: "#262626",
  },
  editBtn: {
    width: 36,
    height: 36,
    color: "primary.main",
    borderRadius: "50%",
    "& .MuiSvgIcon-root": { fontSize: 20 },
    "&:hover": {
      bgcolor: "#E3F2FD",
    },
  },
  chipList: {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
  },
  chip: {
    fontSize: 14,
    color: "#262626",
    bgcolor: "#F0F0F0",
    borderRadius: "16px",
    px: "12px",
    py: "6px",
  },
  dashedBtn: {
    border: "1.5px dashed #CCCCCC",
    borderRadius: "8px",
    py: "32px",
    px: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: "8px",
    bgcolor: "#fcfcfc",
    cursor: "pointer",
    transition: "all 150ms",
    "&:hover": {
      borderColor: "primary.main",
      bgcolor: "#E8F1FE",
      "& .dashed-icon": {
        borderColor: "primary.main",
        color: "primary.main",
      },
    },
  },
  dashedIcon: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    bgcolor: "white",
    border: "1.5px solid #CCCCCC",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#7C7C7C",
    transition: "all 150ms",
  },
  dashedTitle: {
    fontSize: 15,
    fontWeight: 500,
    color: "#262626",
    mt: "4px",
  },
  dashedSub: {
    fontSize: 13,
    color: "#7C7C7C",
    maxWidth: 380,
    lineHeight: 1.45,
  },
}

const getTemplateLabel = (entry) => {
  const match = ALL_LABEL_TEMPLATES.find(t => t.value === entry.value && t.brand === entry.brand)
  return match ? match.label : entry.value
}

const LabelTemplatesSection = () => {
  const enterprise = useSelector(getOrganizationsEnterpriseSelector)
  const [editOpen, setEditOpen] = useState(false)

  if (!enterprise) return null

  const selected = enterprise.labelTemplates || []
  const isEmpty = selected.length === 0

  return (
    <Box sx={sx.card}>
      <Box sx={sx.cardHead}>
        <Typography sx={sx.cardTitle}>Étiquettes</Typography>
        {!isEmpty && (
          <IconButton
            size="small"
            sx={sx.editBtn}
            onClick={() => setEditOpen(true)}
            aria-label="Modifier les templates d'étiquette"
          >
            <EditIcon />
          </IconButton>
        )}
      </Box>

      {isEmpty ? (
        <Box
          sx={sx.dashedBtn}
          onClick={() => setEditOpen(true)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && setEditOpen(true)}
        >
          <Box sx={sx.dashedIcon} className="dashed-icon">
            <AddIcon sx={{ fontSize: 20 }} />
          </Box>
          <Typography sx={sx.dashedTitle}>Sélectionner des templates d&apos;étiquette</Typography>
          <Typography sx={sx.dashedSub}>Choisissez parmi les gabarits disponibles</Typography>
        </Box>
      ) : (
        <Box sx={sx.chipList}>
          {selected.map((entry, index) => (
            <Box key={`${entry.value}-${entry.brand}-${index}`} component="span" sx={sx.chip}>
              {getTemplateLabel(entry)}
            </Box>
          ))}
        </Box>
      )}

      <EditLabelTemplatesModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        enterpriseId={enterprise.objectId}
        selected={selected}
      />
    </Box>
  )
}

export default LabelTemplatesSection
